import { CircleX, FileCheck2 } from "lucide-react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useEffect, useState } from "react";
import ApiRequest from "../../../../../lib/ApiCall";
import { ErrorFlash, SuccessFlash } from "../../../../../lib/flash-notification";
import FullscreenModalWrapper from "../../../../../components/modal/wrapper/fullscreen-modal-wrapper";
import SpinnerLoader from "../../../../../components/loader/spinner-loader";

interface Payment {
  payment_type_id: string;
  member_id?: string;
}

interface PaymentFormProps {
  openModal: boolean;
  onCloseModal: () => void;
  onSuccess: (data: any) => void;
  availablePaymentTypes: {
    uuid: string;
    name: string;
    amount: string;
  }[];
  member_id: string;

}

const AddPaymentForm = ({ openModal, onCloseModal, onSuccess, availablePaymentTypes, member_id }: PaymentFormProps) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const schema = yup.object({
    payment_type_id: yup.string().required("Please select a payment type"),
    amount: yup.string().nullable(),
    description: yup.string().nullable(),
    // member_id: yup.string().required('Please select a member'),
  });

  const { register, handleSubmit, setValue, formState: { errors }, reset } = useForm({
    resolver: yupResolver(schema)
  });

  useEffect(() => {
    if (openModal) reset({ payment_type_id: '', amount: '', description: '' });
  }, [openModal]);

  const onSubmit = async (data: Payment) => {
    setLoadingSubmit(true);
    data.member_id = member_id;

    try {
      const request = await ApiRequest({
        endpoint: 'payment/add', // POST /payments
        method: 'POST',
        payload: data
      });

      setLoadingSubmit(false);

      if (request.status === '200') {
        SuccessFlash("Payment added successfully");
        onSuccess(request.data);
        onCloseModal();
        return;
      }

      ErrorFlash(request.message);

    } catch (err) {
      setLoadingSubmit(false);
      ErrorFlash("Failed to add payment");
      console.error(err);
    }
  };

  return (
    <>
      {openModal &&
        <FullscreenModalWrapper>
          <form onSubmit={handleSubmit(onSubmit)} className="p-5">
            <button onClick={onCloseModal} type="button" className="absolute top-3 right-5">
              <CircleX size={30} />
            </button>

            <h2 className="mb-5">Add Payment</h2>

            <div className="grid gap-4">
              <div >

                <select style={{ border: 'solid 1px #000', padding: '10px', borderRadius: '6px' }}
                  {...register('payment_type_id')}
                  className="input-field"
                >
                  <option value="">Select payment type</option>
                  {availablePaymentTypes.map(pt => (
                    <option key={pt.uuid} value={pt.uuid}>
                      {pt.name} - NGN {pt.amount}
                    </option>
                  ))}
                </select>
                {errors.payment_type_id && <p className="text-red-500">{errors.payment_type_id.message}</p>}
              </div>

              <button
                disabled={loadingSubmit}
                className={`pryBtn w-fit ${loadingSubmit ? 'opacity-50' : ''}`}
              >
                <FileCheck2 size={18} />
                <span>Submit</span>
                {loadingSubmit && <SpinnerLoader />}
              </button>
            </div>
          </form>
        </FullscreenModalWrapper>
      }
    </>
  );
};

export default AddPaymentForm;
